<template>
  <div>
    <el-row>
      <div class="model-header">
        <h2>Cập nhật danh sách môn học chuyên ngành {{ modelData.name }}</h2>
        <!-- <el-button @click="backModel" size="small" class="btn-back">Trờ về</el-button> -->
      </div>
    </el-row>
    <el-row>
      <div class="model-content">
        <el-col :span="12">

        </el-col>
        <div style="padding-top: 20px">
          <el-button
            :disable="!canSubmit"
            :loading="!canSubmit"
            type="warning"
            size="small"
            @click="storeModel()">Cập nhật</el-button>
        </div>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'ConfigmenuCreate',
  metaInfo () {
    return {
      title: 'Chuyên ngành'
    }
  },
  data () {
    return {
      canSubmit: true,
      modelData: {
        level_id: '',
        name: '',
        code: '',
        status: true
      },
      configData: {
        level: {
          id: 0,
          name: 'Tên khóa này'
        }
      },
      lists: {
        listCategoryBlogs: [
          {key: 1, value: 'Menu chính'},
          {key: 2, value: 'Footer cột Giới thiệu'},
          {key: 3, value: 'Footer cột Cộng tác viên Affiliate'},
          {key: 4, value: 'Footer cột Chính sách'}
        ],
        listLevel: []
      },
      rules: {
        name: [
          { required: true, message: 'Vui lòng nhập tên chuyên ngành' }
        ]
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchModel()
  },
  methods: {
    // Lấy action từ Vuex
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'facults-create', text: 'Cập nhật' }
      ]

      this.setBreadcrumb(breadcrumb)
    },
    // Nút back lại trang Index
    backModel () {
      this.$router.push({name: 'levels-show', params: {level_id: this.$route.params.level_id}})
      // this.$router.push({name: 'facults-index'})
    },
    // Tải dữ liệu Model xuống
    fetchModel () {
      this.canSubmit = false
      axios.get('facults/' + this.$route.params.facult_id).then(response => {
        switch (response.code) {
          case 200:
            this.canSubmit = true
            this.modelData = response.data
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Lưu dữ liệu
    submitForm (formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.storeModel()
        } else {
          this.$notify({
            title: 'Lỗi dữ liệu nhập',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
          return false
        }
      })
    },
    storeModel () {
      this.canSubmit = false
      axios.put('facults/' + this.$route.params.facult_id, this.modelData).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật thành công',
              type: 'success'
            })
            // this.$router.push({name: 'levels-show', params: {level_id: this.$route.params.level_id}})
            // this.$router.push({name: 'facults-index'})
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-content {
  padding-top: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/facults/Update.vue